// Copyright 2026 Bitech.id. Licensed under the MIT License.

import type { Breadcrumb } from '../types.js';

export const DEFAULT_MAX_BREADCRUMBS = 100;

export class BreadcrumbBuffer {
  private readonly items: Breadcrumb[] = [];

  constructor(private readonly maxItems: number = DEFAULT_MAX_BREADCRUMBS) {}

  add(breadcrumb: Omit<Breadcrumb, 'timestamp'> & { timestamp?: string }): void {
    this.items.push({
      ...breadcrumb,
      timestamp: breadcrumb.timestamp ?? new Date().toISOString(),
    });
    if (this.items.length > this.maxItems) {
      this.items.shift();
    }
  }

  getAll(): Breadcrumb[] {
    return [...this.items];
  }

  clear(): void {
    this.items.length = 0;
  }
}
